import { useEffect } from 'react';

import StyledSelect from '@components/general/styled-select.component';

const ACCESS_OPTIONS = [
  { label: 'can view', value: 'Viewer' },
  { label: 'can edit', value: 'Editor' }
];

/**
 * @param {Object} props
 * @param {Collaborator['access']} props.access
 * @param {(Collaborator['access']) => {}} props.setAccess
 */
const CollectionCollaboratorAccessSelect = ({ access, setAccess }) => {
  useEffect(() => {
    if (!access) {
      setAccess(ACCESS_OPTIONS[0].value);
    }
  }, [access]);

  return (
    <StyledSelect
      options={ACCESS_OPTIONS}
      value={access}
      onChange={setAccess}
      variant='reskin'
    />
  );
};

export default CollectionCollaboratorAccessSelect;
